/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import getSection from './get-section';


export default (state) => {
    return get(getSection(state), 'name', null);
}